/**
 * Returns the corresponding CSS class name for a given brand.
 *
 * @param brand - The brand identifier to get the class name for.
 * @param styles - An object mapping brand names to CSS class names.
 * @returns The CSS class name associated with the specified brand.
 *
 * @remarks
 * If the brand does not match any known case, the 'sun' style is returned by default.
 */

export const getBrandClassName = (
  brand: Content.Properties.Brand,
  styles: Record<string, string>,
): string => {
  switch (brand) {
    case 'golf':
      return styles.golf;

    case 'safari':
      return styles.safari;

    case 'rejseklubben':
      return styles.rejseklubben;

    default:
      return styles.sun;
  }
};
